import React from 'react'
import classes from './Card.module.css'
import { calculate } from '../../../../../assets/icons'
import { Typography } from '@mui/material'

const DashboardCard = ({ title, content, expense }) => {
  return (
    <div className={expense ? classes.eCardWrapper : classes.cardWrapper}>
      <div className={classes.wrapper}>
        <p className={classes.CardTitle}>{title}</p>
        <div className={classes.subwrapper}>
          {!expense && <p className={classes.CardValue}>{content}</p>}
          <div className={expense ? classes.eCardContent : classes.cardContent}>
            {expense && <p className={classes.CardValue}>{content}</p>}
            {/* {stats && (
              <div className={classes.cardStats}>
                <img src={SucessUp} alt="" />
                <Typography className={classes.statsText}>{stats}%</Typography>
              </div>
            )}
            {stats && <Typography className={classes['card-sub-text']}>than last year</Typography>} */}
          </div>
        </div>
      </div>
      {!expense && <img src={calculate} alt="" />}
    </div>
  )
}

export default DashboardCard
